import { AtRiskIndex } from 'modules/AtRisk/Index/AtRiskIndex';
import { Redirect, Route, Switch } from 'react-router-dom';

export const AtRisk = () => {
  return (
    <Switch>
      <Route path="/" component={AtRiskIndex} />
      <Redirect to="/" />
    </Switch>
  );
};
